import { getApiConfig } from "../config/apiconfig";
import { getOidcKey } from "../config/auth0";
import { gZipPost } from "./fetch";
import { getStringFromStorage, removeUserPreference } from "./storagehelper";

export const generateGUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateUniqueCellId = function (uniqueCellId) {
  const [sheetPart, cellPart] = uniqueCellId.split("!");
  const [column, row] = cellPart.match(/\d+|\D+/g);
  const result = columnToIndex(column);
  // cellRefreshSetting(uniqueCellId);
  return `${sheetPart}#${result}#${row}`;
};

function columnToIndex(column) {
  let index = 0;
  for (let i = 0; i < column.length; i++) {
    index = index * 26 + (column.charCodeAt(i) - 64);
  }
  return index - 1; // Zero-based index
}

export function webRequest(data: any, apiURL: string, token: any, profileId: any) {
  const APICONFIG = getApiConfig();
  const url = APICONFIG.APIBASEURL + apiURL;
  data.parameters.userGUID = profileId;
  //return post(token, url + "?profileID=" + profileId + "&type=json", data);
  return gZipPost(token, url + "?profileID=" + profileId + "&type=json", data);
}

export const generateUniqueID = () => {
  const v = new Date().getUTCMilliseconds();
  return v.toString();
};

export function extractProperties(arr, properties) {
  return arr.map((obj) =>
    Object.keys(obj).reduce((acc, key) => {
      if (properties.has(key)) acc[key] = obj[key];
      return acc;
    }, {})
  );
}

export const propsToValueArray = function (arr, properties) {
  return arr.map((obj) => {
    const temp = [];
    properties.forEach((element) => {
      temp.push(obj[element]);
    });
    return temp;
  });
};

export function ExcelDateToJSDate(date) {
  if (date == null) {
    return null;
  }

  if (!isNaN(date)) {
    return new Date((Number(date) - (25567 + 2)) * 86400 * 1000).toLocaleDateString("en-US", { timeZone: "UTC" });
  } else {
    return date;
  }
}

function cellSetting(celladdress) {
  try {
    Excel.run(function (context) {
      const selectActivecell = celladdress.split("!").pop().toString();
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const range = sheet.getRange(selectActivecell);
      range.format.font.size = 11;
      range.format.font.strikethrough = false;
      return context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

export function cellRefreshSetting(celladdress) {
  try {
    Excel.run(function (context) {
      const selectActivecell = celladdress.split("!").pop().toString();
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const range = sheet.getRange(selectActivecell);
      range.format.font.size = 8;
      range.format.font.strikethrough = true;
      context.sync();
      return context.sync().then(function () {
        window.setTimeout(() => {
          cellSetting(celladdress);
        }, 8000);
      });
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

export const ExtractFromJsonComponent = ({
  apiOutputList,
  columnstoBesorted = null,
  isAcendingOrder = true,
  isDirectSingleObject = false,
}) => {
  if (!apiOutputList.length) {
    return null;
  }
  if (apiOutputList[0].toUpperCase() !== "OK") {
    return "Server Returned Error";
  }
  try {
    let result;
    if (isDirectSingleObject) {
      result = [JSON.parse(apiOutputList[2])];
    } else {
      result = JSON.parse(apiOutputList[2]);
    }
    if (columnstoBesorted) {
      result.sort((a, b) => {
        if (isAcendingOrder) {
          return a[columnstoBesorted] > b[columnstoBesorted] ? 1 : -1;
        } else {
          return a[columnstoBesorted] < b[columnstoBesorted] ? 1 : -1;
        }
      });
    }
    return result;
  } catch (error) {
    return "Server Returned Error: " + error.message;
  }
};

export function CheckProfile(): any {
  try {
    const selectedProfile = getStringFromStorage("xl_ProfileId");
    if (selectedProfile != null) return true;
    else return "Please Select the Profile";
  } catch (error) {
    console.log("Error: " + error);
  }
}
export const isValidUser = () => {
  const oidcuser = getStringFromStorage(getOidcKey());
  if (oidcuser == null) {
    removeUserPreference();
    return true;
  }
  return false;
};
